import { EditorFiltrosUnidades } from './EditorFiltrosUnidades'
import { textoAgendamento, textosAgendamento } from './textos'

/**
 * Telas de relatorio fixas que podem ser agendadas, pelo path gravado no agendamento. Usado pela tela do relatorio
 * (botao Agendar) e pela listagem (editar). Cada entrada nova tambem precisa do executor no back e de entrar no
 * CHECK ck_agendamento_relatorio_origem. Textos por chave do dicionario (agendamentorelatorio.label.*).
 * - descricao: chave do nome do relatorio
 * - camposData: linhas da grade de datas, com a chave do rotulo
 * - EditorFiltros: edita os filtros que nao sao data (opcional)
 */
const RELATORIOS_AGENDAVEIS = {
  dre: {
    descricao: 'relatorio.dre',
    camposData: [
      { campo: 'dataInicial', label: 'dre.dataInicial' },
      { campo: 'dataFinal', label: 'dre.dataFinal' },
    ],
    EditorFiltros: EditorFiltrosUnidades,
  },
}

/**
 * O relatorio agendavel do path, com os textos ja resolvidos; null se o path nao estiver registrado.
 *
 * @param textos os textos do dicionario ja carregados (opcional; ver textoAgendamento)
 */
export const getRelatorioAgendavel = (path, textos = textosAgendamento()) => {
  const registro = RELATORIOS_AGENDAVEIS[path]
  if (!registro) {
    return null
  }
  return {
    descricao: textoAgendamento(registro.descricao, textos),
    camposData: registro.camposData.map(({ campo, label }) => ({ campo, label: textoAgendamento(label, textos) })),
    EditorFiltros: registro.EditorFiltros,
  }
}

/** Se o path tem dialogo registrado (sem resolver textos). */
export const isRelatorioAgendavel = (path) => Boolean(RELATORIOS_AGENDAVEIS[path])
